/**
 * @generated SignedSource<<d62d1a2301926c4f560c79d35c5c32a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetLabelContent$data = {
  readonly __typename: "Article";
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly types: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersGetLabelContent";
} | {
  readonly __typename: "Gallery";
  readonly __typename: "Gallery";
  readonly " $fragmentType": "helpersGetLabelContent";
} | {
  readonly __typename: "Video";
  readonly __typename: "Video";
  readonly " $fragmentType": "helpersGetLabelContent";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "helpersGetLabelContent";
};
export type helpersGetLabelContent$key = {
  readonly " $data"?: helpersGetLabelContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetLabelContent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetLabelContent"
};

(node as any).hash = "e60cebef5918fa93650dd87d5d2e1e52";

export default node;
